/**
 * The production domain used for canonical URLs.
 * Canonical tags are only set on the public site (gated by isPublicSite()),
 * so this will not affect internal or local dev builds.
 */
export const CANONICAL_DOMAIN = "https://developer.microsoft.com";

export function buildCanonicalUrl(pageUrl: string, pagePath: string): string {
    return CANONICAL_DOMAIN + pagePath + (pageUrl === "/" ? "/" : "");
}

export function setCanonicalUrl(url: string): void {
    let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
    }
    link.href = url;
}

export function removeCanonicalUrl(): void {
    document.querySelector('link[rel="canonical"]')?.remove();
}
